module.exports = __webpack_public_path__ + "static/media/Bank (25).94d116ae.svg";